import gql from 'graphql-tag';
import apollo from 'src/features/apollo';

const mutation = gql`
  mutation SigninAdviser($model: Json!) {
    signinAdviser(adviser_info: $model) {
      token
      authorizable {
        ... on Customer{
          id
        } 
      } 
    }
  }`;

function parse(item) {
  return {
    token: item.token,
    customer: {
      id: item.authorizable.id,
    },
  };
}

function authSigninAdviser(customInfo) {
  return apollo.client.mutate({
    variables: {
      model: customInfo,
    },
    mutation,
  }).then((res) => parse(res.data.signinAdviser))
    .catch((err) => {
      if (err.graphQLErrors && err.graphQLErrors.length) {
        if (err.graphQLErrors[0].message) {
          throw err.graphQLErrors[0].message;
        } else {
          throw new Error('GraphQL Error without error payload');
        }
      } else {
        throw err;
      }
    });
}

export default authSigninAdviser;
